<template>
	<div class="confirm-modal-wrap">
		<span>{{title}}</span>
		<div>
			<button @click="cancel">{{cancelButton}}</button>
			<button @click="ok">{{okButton}}</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		/*
        confirmprop: {
            okButton ? okButton : 'Ok'
            cancelButton ? cancelButton : 'Cancel'
            title ? title : 'Are you sure?'
            okCallback ? okCallback : ()=>{}
            cancelCallback ? cancelCallback : ()=>{}
        }
    */
		confirmprop: Object
	},
	computed: {
		title() {
			if (this.confirmprop.title) return this.confirmprop.title;
			else return this.$t('button.areYouSure');
		},
		okButton() {
            if (this.confirmprop.okButton) return this.confirmprop.okButton;
			else return this.$t('button.yes');
        },
		cancelButton() {
            if (this.confirmprop.cancelButton) return this.confirmprop.cancelButton;
			else return this.$t('button.cancel');
        },
		okCallback() {
			if (this.confirmprop.okCallback) return this.confirmprop.okCallback;
			else return () => {};
		},
		cancelCallback() {
			if (this.confirmprop.cancelCallback)
				return this.confirmprop.cancelCallback;
			else return () => {};
		}
	},
	mounted() {},
	methods: {
        ok(e){
            this.okCallback(e);
            this.$emit('close');
        },
        cancel(e){
            this.cancelCallback(e);
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
.confirm-modal-wrap {
    z-index: 999;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    min-width: 150px;
    min-height: 100px;
    max-width: 250px;
    max-height: 500px;
    overflow: auto;
    background: white;
    padding: 20px;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.15);
    border-radius: 15px;
    span {
        text-align: center;
        width: 80%;
        margin: 10px auto 30px;
        word-break: break-word;
    }
    div {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        button:focus {
            outline: none;
        }
        button {
            cursor: pointer;
            font-weight: 600;
            font-size: 15px;
            color: white;
            flex-shrink: 1;
            flex-basis: 70px;
            height: 40px;
            border: none;
            background: #888c8e;
            border-radius: 10px;
            margin: 0 5px;
            padding: 0 15px;
        }
    }
}
</style>